var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSortIcon = function SvgSortIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.97977 3.32347L4.24777 0.589469C4.19674 0.538099 4.13606 0.497331 4.06921 0.469511C4.00236 0.44169 3.93067 0.427368 3.85827 0.427368C3.78586 0.427368 3.71417 0.44169 3.64732 0.469511C3.58048 0.497331 3.51979 0.538099 3.46877 0.589469L0.732766 3.32347C0.655637 3.40073 0.603148 3.49912 0.581934 3.6062C0.56072 3.71329 0.571735 3.82426 0.613585 3.92509C0.655435 4.02591 0.726242 4.11206 0.817053 4.17265C0.907863 4.23324 1.0146 4.26554 1.12377 4.26547H6.59077C6.69976 4.26514 6.80622 4.23256 6.89673 4.17182C6.98723 4.11108 7.05773 4.02491 7.09933 3.92416C7.14093 3.82342 7.15178 3.71261 7.1305 3.60571C7.10922 3.49881 7.05678 3.4006 6.97977 3.32347Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSortIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "sort-icon.7d3df75f0cb82ee6aa11936512f527c5.svg";